/* email.ts — assemble mailto links at runtime.
 *
 * Keeps the full address out of the served HTML. Mark up a placeholder with the
 * two halves and, optionally, link text:
 *
 *   <a data-email-user="someone" data-email-domain="example.edu">Email</a>
 *   <p data-email-user="someone" data-email-domain="example.edu"></p>
 *
 * An empty element gets "user [at] domain" as its text; one with existing text
 * (e.g. "Email") keeps it. Replaces two near-identical inline snippets that had
 * drifted into different shapes in the footer and on the home page.
 */

(function () {
    'use strict';

    const hosts = document.querySelectorAll<HTMLElement>('[data-email-user][data-email-domain]');

    hosts.forEach(function (el) {
        const user = el.dataset.emailUser;
        const domain = el.dataset.emailDomain;
        /* The selector requires both attributes, so this cannot fire in
           practice — but an empty one would previously have produced a
           mailto:undefined@undefined link rather than nothing. */
        if (!user || !domain) {
            return;
        }
        const address = user + '@' + domain;
        const obfuscated = user + ' [at] ' + domain;
        const existing = el.textContent.trim();

        /* instanceof rather than tagName === 'A': same test, and it is the one
           that tells the checker `href` is available here. */
        if (el instanceof HTMLAnchorElement) {
            el.href = 'mailto:' + address;
            if (existing === '') {
                el.textContent = obfuscated;
            }
            return;
        }

        const link = document.createElement('a');
        link.href = 'mailto:' + address;
        link.textContent = existing || obfuscated;
        el.textContent = '';
        el.appendChild(link);
    });
})();
